import type { SVGProps } from "react";

export default function IconPdf(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 170 170" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g transform="matrix(0.26458333,0,0,0.26458333,-855.2267,-447.8243)">
        <circle
          transform="matrix(0.7071,-0.7071,0.7071,0.7071,-542.1661,3010.1943)"
          fill="#f7921e"
          cx="3362.543"
          cy="2159.55"
          id="ellipse270"
          r="34.041"
        />

        <path
          d="m 3362.543,2200.091 c -22.354,0 -40.541,-18.187 -40.541,-40.541 0,-22.354 18.187,-40.541 40.541,-40.541 22.354,0 40.541,18.187 40.541,40.541 0,22.354 -18.187,40.541 -40.541,40.541 z m 0,-68.082 c -15.187,0 -27.541,12.354 -27.541,27.541 0,15.187 12.354,27.541 27.541,27.541 15.187,0 27.541,-12.354 27.541,-27.541 0,-15.187 -12.355,-27.541 -27.541,-27.541 z"
          id="path270"
        />

        <path
          fill="#ffffff"
          d="M 3612.374,1738.136 H 3446.74 c -45.206,0 -81.852,36.646 -81.852,81.852 v 392.66 c 0,45.206 36.646,81.852 81.852,81.852 h 236.296 c 45.206,0 81.852,-36.646 81.852,-81.852 v -321.996 z"
          id="path271"
        />

        <path
          d="M 3683.037,2301 H 3446.74 c -48.717,0 -88.352,-39.635 -88.352,-88.352 v -392.66 c 0,-48.717 39.635,-88.352 88.352,-88.352 h 165.633 c 1.724,0 3.377,0.685 4.597,1.904 l 152.515,152.515 c 1.22,1.219 1.904,2.872 1.904,4.596 v 321.997 c 0,48.717 -39.635,88.352 -88.352,88.352 z M 3446.74,1744.637 c -41.549,0 -75.352,33.803 -75.352,75.352 v 392.66 c 0,41.549 33.803,75.352 75.352,75.352 h 236.297 c 41.549,0 75.352,-33.803 75.352,-75.352 v -319.304 l -148.708,-148.708 z"
          id="path272"
        />
        <path
          fill="#dcddde"
          d="m 3612.374,1738.136 152.515,152.516 h -119.99 c -17.963,0 -32.525,-14.562 -32.525,-32.525 z"
          id="path273"
        />

        <path
          d="m 3764.908,1897.152 c 0,0 -0.012,0 -0.02,0 h -119.99 c -21.519,0 -39.025,-17.507 -39.025,-39.025 v -119.99 c 0,-2.629 1.584,-4.999 4.013,-6.005 2.427,-1.005 5.225,-0.45 7.083,1.409 l 152.222,152.221 c 1.36,1.191 2.218,2.94 2.218,4.89 0,3.59 -2.91,6.5 -6.501,6.5 z m -146.035,-143.323 v 104.297 c 0,14.351 11.675,26.025 26.025,26.025 h 104.298 z"
          id="path274"
        />

        <path
          fill="#f7921e"
          d="m 3365.638,1963.255 c -20.219,0 -36.61,16.391 -36.61,36.61 v 153.307 h 0.671 c 3.256,-16.885 18.104,-29.64 35.939,-29.64 h 368.677 v -160.276 h -368.677 z"
          id="path275"
        />

        <path
          d="m 3329.698,2159.672 h -0.671 c -3.59,0 -6.5,-2.91 -6.5,-6.5 v -153.307 c 0,-23.771 19.339,-43.11 43.11,-43.11 h 368.678 c 3.59,0 6.5,2.91 6.5,6.5 v 160.276 c 0,3.59 -2.91,6.5 -6.5,6.5 h -368.678 c -14.403,0 -26.834,10.25 -29.557,24.371 -0.589,3.06 -3.267,5.27 -6.382,5.27 z m 35.94,-189.917 c -16.603,0 -30.11,13.507 -30.11,30.11 v 129.438 c 7.839,-7.643 18.529,-12.272 30.11,-12.272 h 362.178 v -147.276 z"
          id="path276"
        />

        <path
          fill="#ffffff"
          d="m 3427.069,2004.067 c 0,-2.708 2.215,-4.924 4.8,-4.924 h 27.45 c 19.448,0 32.25,10.34 32.25,27.327 v 0.246 c 0,18.587 -15.51,28.188 -33.851,28.188 h -20.926 V 2081 c 0,2.708 -2.215,4.924 -4.924,4.924 -2.585,0 -4.8,-2.216 -4.8,-4.924 v -76.933 z m 31.019,41.975 c 14.279,0 23.634,-7.632 23.634,-18.956 v -0.246 c 0,-12.31 -9.231,-18.711 -23.141,-18.711 h -21.788 v 37.913 z"
          id="path277"
        />

        <path
          fill="#ffffff"
          d="m 3509.3,2004.067 c 0,-2.708 2.215,-4.924 4.8,-4.924 h 25.111 c 27.08,0 45.79,18.587 45.79,42.837 v 0.246 c 0,24.249 -18.71,43.082 -45.79,43.082 H 3514.1 c -2.585,0 -4.8,-2.216 -4.8,-4.924 z m 29.911,72.256 c 21.787,0 35.697,-14.771 35.697,-33.851 v -0.246 c 0,-19.08 -13.91,-34.098 -35.697,-34.098 h -20.188 v 68.194 h 20.188 z"
          id="path278"
        />

        <path
          fill="#ffffff"
          d="m 3605.563,2004.067 c 0,-2.708 2.215,-4.924 4.8,-4.924 h 53.3 c 2.462,0 4.431,1.97 4.431,4.432 0,2.462 -1.969,4.554 -4.431,4.554 h -48.376 v 30.773 h 42.837 c 2.462,0 4.431,1.97 4.431,4.432 0,2.462 -1.969,4.432 -4.431,4.432 h -42.837 V 2081 c 0,2.708 -2.215,4.924 -4.924,4.924 -2.585,0 -4.8,-2.216 -4.8,-4.924 z"
          id="path279"
        />
      </g>
    </svg>
  );
}
